/* eslint-disable @typescript-eslint/no-unused-vars */
import { ButtonBase, Typography } from '@material-ui/core'
import React from 'react'

import { persianRegex } from '../../helpers/regex'
import { getTranslate } from '../../localization'
import { LocalizedLink } from '../../routes/localizedRoutes'
import { UserBrief } from '../../types/users'
import { UserRowMenu } from './UserRowMenu'
import useStyles from './styles/UsersTable.styles'

interface UserRowProps {
  data: UserBrief
}

const UserRow: React.FC<UserRowProps> = ({ data }) => {
  const classes = useStyles()
  const { ID, active, email, entityName, role, name } = data

  const isPersianName = persianRegex.test(name)
  const isPersianEntityName = persianRegex.test(entityName)

  return (
    <div className={classes.tableRowRoot}>
      <ButtonBase
        className={classes.tableRow}
        component={LocalizedLink}
        to={`/access-management/user-management/user/${ID}`}>
        <div>
          <Typography variant="body1">{name}</Typography>
        </div>
        <div>
          <Typography variant="body1">{email}</Typography>
        </div>
        <div>
          <Typography variant="body1">{role}</Typography>
        </div>
        <div>
          <Typography
            variant="body1"
            style={
              isPersianEntityName ? { fontFamily: 'IranSans' } : undefined
            }>
            {entityName}
          </Typography>
        </div>
        <div>
          {active ? getTranslate('Active') : getTranslate('Not Active')}
        </div>
      </ButtonBase>
      <UserRowMenu data={data} />
    </div>
  )
}

export default UserRow
